import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';
/**
 * BaseElement:
 *    renders the base table in modal window
 */
export function BaseElement(props) {
  return <div className={`ps_content_base ${props.className}`} />;
}

BaseElement.propTypes = {
  /**
   * classname
   */
  className: PropTypes.string,
};

PropTypes.defaultProps = {
  className: '',
};
